import { Box, Grid } from '@mui/material';
import { FC } from 'react';
import YearLink from './YearLink';

interface PreviousNextYearLinks {
    nextYear?: string;
    previousYear?: string;
}
const PreviousNextYearLinks: FC<PreviousNextYearLinks> = ({ nextYear, previousYear }) => {
    return (
        <Box sx={{ mb: 2, mt: 8 }}>
            <Grid spacing={3} container>
                <Grid sm={6} xs={12} item>
                    {previousYear && <YearLink year={previousYear} />}
                </Grid>
                <Grid sm={6} xs={12} item>
                    {nextYear && <YearLink year={nextYear} isNext />}
                </Grid>
            </Grid>
        </Box>
    );
};

export default PreviousNextYearLinks;
